<template>
	<DialogDescription
		:as="VText"
		:class="clsx(className, 'mt-2 text-pretty text-center sm:text-left')">
		<slot />
	</DialogDescription>
</template>

<script setup lang="ts">
	import {
		clsx,
	} from "clsx"

	import {
		DialogDescription,
	} from "@headlessui/vue"

	import VText from "@/components/Text/VText.vue"

	const props = defineProps({
		className: {
			type: String,
			default: "",
		},
	})
</script>